<template>
  <div>
    <div class="list-item">
      <p class="list-item-title">订单号：</p>
      <p class="list-item-time">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">订单金额：</p>
      <p class="list-item-time yellow">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">项目：</p>
      <p class="list-item-time">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">下单时间：</p>
      <p class="list-item-time">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">是否完成：</p>
      <p class="list-item-time">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">是否入账：</p>
      <p class="list-item-time">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">推广佣金：</p>
      <p class="list-item-time yellow">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">优惠券：</p>
      <p class="list-item-time red">777</p>
    </div>
    <div class="list-item">
      <p class="list-item-title">分成：</p>
      <p class="list-item-time red">777</p>
    </div>
    <!-- <List
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
        <div class="list-item">
          <p class="list-item-title">订单号：</p>
          <p class="list-item-time">777</p>
        </div>
    </List> -->
  </div>
</template>
<script>
import { List } from "vant";

export default {
  components: {
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
    };
  },
  methods: {
    onLoad() {
      this.getList();
      this.page++;
    },
    getList() {
      this.api.myDetailed({ page: this.page }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list-item {
  padding: 0 0.24rem;
  height: 0.8rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  font-weight: bold;
  &:first-child {
    background: #f5f5f5;
  }
  .list-item-title {
    font-size: 0.3rem;
    font-weight: bold;
    color: #666666;
  }
  .list-item-time {
    font-size: 0.32rem;
    font-weight: 400;
    color: #666;
    &.yellow{
      color: #FFA380;
    }
    &.red{
      color: #F9647D;
    }
  }
  .list-item-state {
    flex: 1;
    text-align: right;

    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
    margin-right: 0.58rem;
  }
  .list-item-more {
    .num {
      font-size: 0.3rem;
      font-weight: 400;
      color: #ffa380;
      margin-right: 0.12rem;
    }
    i {
      font-size: 12px;
      color: #cccccc;
    }
  }
}
</style>
